import React from 'react';
import { Button } from 'semantic-ui-react';

export function ButtonLink({ className = '', ...props }) {
  return (
    <Button
      basic
      color='blue'
      className={['link', className].join(' ')}
      {...props}
    />
  );
}

export default ButtonLink;
